import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=a8f1420c&scoped=true&"
var script = {}
import style0 from "./copyright.vue?vue&type=style&index=0&id=a8f1420c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f1420c",
  null
  
)

export default component.exports